export default {
    namespaced: true, // 当 namespaced 设置为true之后引入在index中的时候不会与其他相同名称的数据或方法发生冲突
    state: {
        vtourData: [],
        vtourOption:{
            baseurl: "",
            // console: false,
            pano: "",
        },
        activedPanoId: "",
        routerActivedPanoId: '',
        isDomShow: false,
    },
    mutations: {
        setRouterActivedPanoId(state,id){
            state.routerActivedPanoId = id;
        },
        setVtourOption(state){
            let str = window.location.href.replace(/\./g,"").replace(/http:\/\//g,"").split(":")[0];
            if(str.indexOf("localhost") != -1 || isNaN(str) == false){
                // state.vtourOption.baseurl = "http://192.168.31.210:52808/";
                state.vtourOption.baseurl = "https://hmltec.oss-cn-beijing.aliyuncs.com/jingshan/vtours/"
            }else{
                state.vtourOption.baseurl = "https://hmltec.oss-cn-beijing.aliyuncs.com/jingshan/vtours/";
            }
        },
        addvtourData(state,arr){
            state.vtourData = arr;
             // console.log("krpano打印",state.vtourData);
        },
        setActivePanoId(state,activedPanoId){
             // console.log(activedPanoId);
			state.activedPanoId = activedPanoId;
        },
        domHied(state){
             // console.log("所有元素消失");
            state.isDomShow = false;
        },
        domShow(state){
             // console.log("所有元素显示");
            state.isDomShow = true;
        },
    }
}